import { render } from "./BaseRoseButton.vue?vue&type=template&id=ff3fcb0a"
import script from "./BaseRoseButton.vue?vue&type=script&lang=js"
export * from "./BaseRoseButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__